<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import createPersonel from "./create_personel.vue";
import { globalStatus }  from "@/helpers/helper"

export default {
  page: {
    title: "Teknik Personel Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    createPersonel,
  },
  data() {
    return {
        list: {},
        title: "TEKNİK PERSONEL LİSTESİ",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "TEKNİK PERSONEL LİSTESİ",
            active: true,
          },
        ],
        isLoading: false,
        rows: [],
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: [
            {
              field: '',
              type: '',
            },
          ],
          page: 1,
          perPage: 50,
        },
        currentPage: 0,
        selected: 0,
        pageLength: 0,
        url: "technic-service/personal",
        paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdown: [50, 100, 200],
          nextLabel: 'Sonraki',
          prevLabel: 'Önceki',
          rowsPerPageLabel: 'Kayıt Göster',
          ofLabel: 'of',
          pageLabel: 'sayfa', // for 'pages' mode
          infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
      },
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: false,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
      columns: [
        {
          label: 'İsim Soyisim',
          field: 'name',
          filterOptions: {
            enabled: true,
            placeholder: 'İsim Soyisim Filtrele',
            filterDropdownItems: [],
          },
        },
        {
          label: 'Kullanıcı Adı',
          field: 'username',
          sortable: false,
          filterOptions: {
            enabled: true,
            placeholder: 'Kullanıcı Adı Filtrele',
            filterDropdownItems: [ ],
          },
        },
        {
          label: 'Durum',
          field: this.status,
          html: true,
          sortable: false,
          filterOptions: {
            filterValue: -1,
            enabled: true,
            placeholder: 'Durum Filtrele',
            filterDropdownItems: [
              {
                value: 0,
                text: 'Pasif',
              },
              {
                value: 1, 
                text: 'Aktif',
              },
              {
                value: -1, 
                text: 'Tümü',
              },
            ],
          },
        },
        {
          field: '#',
          sortable: false,
          thClass: 'width-50',
        },
      ],
    };
  },
   mounted() {
    //this.loadItems()
  },
  methods: {
    status(rowObj) {
      return globalStatus(rowObj.status);
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
    return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.data,
              totalRecords: res.data.total,
              pageLength: res.data.last_page,
              currentPage: res.data.current_page,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    selectionChanged(a) {
      this.selected = a.selectedRows.length
    },
    onSearch(params) {
       this.updateParams(params)
        this.loadItems()
    },
    create(){
       this.list = {}
       this.$parent.$bvModal.show('modal-scoped')
    },
    update(props){
       this.list = props
       this.$parent.$bvModal.show('modal-scoped')
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <create-personel :list="list" @loadItems="loadItems" />
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{
                    enabled: false,
                    placeholder: 'Arama İçin Enter\'a Basınız'
                  }"
                @on-search="onSearch"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-selected-rows-change="selectionChanged"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <div slot="table-actions">
                    <button 
                    class="btn btn-success btn-sm" 
                    style="margin-right:10px;margin-top:2px" 
                    type="button" 
                    @click="create()"
                    >Yeni Oluştur
                    </button>
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span
                    v-if="props.column.field === '#'"
                    class="text-nowrap"
                  >
                     <ul class="list-inline font-size-20 contact-links mb-0">
                        <li class="list-inline-item">
                          <a v-b-tooltip.hover title="Düzenle" @click="update(props.row)">
                            <i class="mdi mdi-circle-edit-outline"></i>
                          </a>
                        </li>
                      </ul>
                  </span>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>